import React, { FC, useState } from 'react';
import { ButtonProps, Button } from 'reactstrap';

interface Props extends ButtonProps {
  onStart?: () => any;
  onFinish?: () => any;
}

const ProcessingButton: FC<Props> = ({ children, disabled, onClick, onStart, onFinish, ...rest }) => {
  const [busy, setBusy] = useState(false);
  return (
    <Button
      {...rest}
      disabled={busy || disabled}
      onClick={async (...args) => {
        try {
          setBusy(true);
          onStart?.()
          await onClick(...args);
        } finally {
          setBusy(false);
          onFinish?.()
        }
      }}
      data-test-running={busy}
    >
      {children}
    </Button>
  );
};

export default ProcessingButton;
